import { ca } from '@cian/analytics';

import { type FC } from 'react';

import { boundActionsFactory } from '@/packages/redux-state/store';

import { BackToListingButton } from './components/BackToListingButton';

const useBoundedActions = boundActionsFactory(reduxActions => ({
  clearActivePin: reduxActions.mapControls.clearActivePin,
}));

export const BackToListingButtonContainer: FC = () => {
  const { clearActivePin } = useBoundedActions();

  const track = (): void =>
    ca('eventSite', {
      action: 'click_sopr',
      category: 'Listing',
      label: 'return_to_list',
      name: 'oldevent',
    });

  return <BackToListingButton track={track} onClick={clearActivePin} />;
};
